module.exports = __webpack_public_path__ + "img/Tick.cc8170d9.png";